import { ROLES } from '@/constants';

const routes = [
  {
    path: '/inbox',
    name: 'inbox',
    component: () => import('./views/Inbox.vue'),
    meta: {
      title: 'Входящие',
    },
  },
  {
    path: '/group-inbox',
    name: 'group-inbox',
    component: () => import('./views/GroupQuestion/index.vue'),
    meta: {
      title: 'Входящие',
    },
  },

  {
    path: '/monitoring',
    name: 'monitoring',
    component: () => import('./views/Monitoring.vue'),
    meta: {
      accessList: [ROLES.support, ROLES.region],
      title: 'Мониторинг',
    },
  },
  {
    path: '/application/:id',
    name: 'application',
    component: () => import('./views/Question/index.vue'),
    meta: {
      title: 'Обращение',
    },
  },
  {
    path: '/trash',
    name: 'trash',
    component: () => import('./views/Trash.vue'),
    meta: {
      title: 'Корзина',
    },
  },
  {
    path: '/test-question',
    name: 'test-question',
    component: () => import('./views/TestQuestion/index.vue'),
    meta: {
      title: 'Тестовое обращение',
    },
  },
];

export default routes;
